import React, { useState } from 'react'
import { Layout as LayoutComponent, Menu, Button } from 'antd'
import {
	PieChartOutlined,
	UserOutlined,
	PoweroffOutlined,
	TeamOutlined,
	CopyOutlined,
	FileTextOutlined,
	WalletOutlined,
	AuditOutlined,
	DollarOutlined,
	MobileOutlined,
	FileSearchOutlined,
	// FileOutlined,
	// TeamOutlined,
	// DesktopOutlined,
} from '@ant-design/icons'
import { useAppDispatch } from 'hooks/reduxHooks'
import { logoutAction } from 'slices/auth'
import { Outlet, Link, useLocation } from 'react-router-dom'
import { RiBroadcastLine } from 'react-icons/ri'
import Breadcrumb from 'component/Breadcrumb'
import logout from 'api/auth/logout'
import localStorage from 'utils/localStorage'
import styles from './styles.module.scss'

const { Header, Content, Footer, Sider } = LayoutComponent
// const { SubMenu } = Menu

/**
 * Layout component for the application which contains the header, footer, sidebar and the main content of the application (outlet)
 *
 * Has a special <Outlet /> component which is used to render the main content of the application using react-router-dom
 */
const Layout: React.FC = () => {
	const environment: string = process.env.REACT_APP_EDGE_MODE || 'STAGING'

	/**
	 * Local state for collapsed menu
	 *
	 * @type {boolean}
	 */
	const [collapsed, setCollapsed] = useState(false)

	const dispatch = useAppDispatch()

	/**
	 * Logs out user from the application and redirect to login page when user clicks on logout button.
	 */
	const handleLogout = async () => {
		await logout()
		dispatch(logoutAction())
	}

	const onCollapse = (val: boolean) => {
		setCollapsed(val)
	}

	/**
	 * Pathname is used to determine which menu item is active in the sidebar
	 */
	const { pathname } = useLocation()

	return (
		<LayoutComponent className={styles.layoutComponent}>
			<Sider
				collapsible
				collapsed={collapsed}
				onCollapse={onCollapse}
				className={styles.layoutComponent_sidebar}
			>
				<div className='logo' />
				<Menu
					theme='dark'
					selectedKeys={[
						pathname,
						pathname.length > 2 ? `/${pathname.split('/')[1]}` : '',
					]}
					defaultSelectedKeys={['1']}
					mode='inline'
				>
					<Menu.Item key='/dashboard' icon={<PieChartOutlined />}>
						<Link to='/dashboard'>Dashboard</Link>
					</Menu.Item>
					<Menu.Item key='/clients' icon={<TeamOutlined />} title='Clients'>
						<Link to='/clients'>Clients</Link>
					</Menu.Item>
					<Menu.Item key='/templates' icon={<CopyOutlined />} title='Templates'>
						<Link to='/templates'>Templates</Link>
					</Menu.Item>
					<Menu.Item key='/invoices' icon={<FileTextOutlined />} title='Invoices'>
						<Link to='/invoices'>Invoices</Link>
					</Menu.Item>
					<Menu.Item key='/wallet' icon={<FileTextOutlined />} title='wallet'>
						<Link to='/wallet'>Wallet report</Link>
					</Menu.Item>
					<Menu.Item key='/payments' icon={<WalletOutlined />} title='Payments'>
						<Link to='/payments'>Payments</Link>
					</Menu.Item>
					<Menu.Item key='/pricing' icon={<DollarOutlined />} title='Pricing'>
						<Link to='/pricing'>Pricing Management</Link>
					</Menu.Item>
					<Menu.Item key='/admins' icon={<UserOutlined />} title='Admin'>
						<Link to='/admins'>Admins</Link>
					</Menu.Item>
					<Menu.Item key='/broadcasts' icon={<RiBroadcastLine />} title='Admin'>
						<Link to='/broadcasts'>Broadcasts</Link>
					</Menu.Item>
					<Menu.Item
						key='/subscriptions'
						icon={<AuditOutlined />}
						title='Admin'
						hidden={environment !== 'STAGING'}
					>
						<Link to='/subscriptions'>Subscriptions</Link>
					</Menu.Item>
					<Menu.Item
						key='/pulse-release'
						icon={<MobileOutlined />}
						title='Pulse Release'
					>
						<Link to='/pulse-release'>Pulse Release</Link>
					</Menu.Item>
					<Menu.Item
						key='/agent-app-release'
						icon={<MobileOutlined />}
						title='Agent App Release'
					>
						<Link to='/agent-app-release'>Agent App Release</Link>
					</Menu.Item>
					<Menu.Item
						key='/work-reports'
						icon={<FileSearchOutlined />}
						title='Work Reports'
					>
						<Link to='/work-reports'>Work Reports</Link>
					</Menu.Item>
					{/* <SubMenu key='sub2' icon={<TeamOutlined />} title='Admins'>
						<Menu.Item key='6'>Team 1</Menu.Item>
						<Menu.Item key='8'>Team 2</Menu.Item>
					</SubMenu>
					<Menu.Item key='9' icon={<FileOutlined />}>
						Files
					</Menu.Item> */}
				</Menu>
			</Sider>
			<LayoutComponent
				className={`${collapsed ? 'collapsed_rightSide' : 'noCollapsed_rightSide'}`}
			>
				<Header className='site-layout-background' style={{ textAlign: 'right' }}>
					<Button
						type='primary'
						icon={<PoweroffOutlined />}
						onClick={handleLogout}
					/>
				</Header>
				<Content style={{ margin: '0 16px', overflow: 'initial' }}>
					<Breadcrumb />
					<div
						className='site-layout-background'
						style={{ padding: 24, minHeight: 360 }}
					>
						<Outlet />
					</div>
				</Content>
				<Footer style={{ textAlign: 'center' }}>
					{localStorage.get('platform')} - WhatCX ©2022 Created by Cobold Digital
					LLP.
				</Footer>
			</LayoutComponent>
		</LayoutComponent>
	)
}

export default Layout
